// extracted by mini-css-extract-plugin
export default {"root":"ElementWrapper_root__1bVyl"};